import { render } from "./GCBMCreate.vue?vue&type=template&id=6ebc8184"
import script from "./GCBMCreate.vue?vue&type=script&lang=js"
export * from "./GCBMCreate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/flint.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__